<template>
  <div class="section-block__top">
    <h2 class="section-block__header">
      <slot name="header"></slot>
    </h2>

    <div v-if="isTopRightPopulated" class="section-block__top-right">
      <slot name="top-right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isTopRightPopulated() {
      return this.$slots['top-right'] !== undefined
    }
  }
}
</script>
